module.exports = __webpack_public_path__ + "img/视频封面4.f27724ae.png";